import useTenantConfigData from 'src/careflow/ph-core/multi-tenant/tenant/hook/useTenantConfigData';
import { useMemo } from 'react';
import AddAddress from './AddAddress';
import { CircularProgress } from '@mui/material';

const AddAddressLoading = ({
  handleClose,
  handleSave,
  isEditable,
  externalAddress,
  childrenTop,
  childrenBottom,
  disabled,
  externalError,
  use,
  onDirtyChange,
}: any) => {
  const { configurations } = useTenantConfigData();

  const configuration = useMemo(() => configurations ?? null, [configurations]);

  if (!configuration) {
    return <CircularProgress color="inherit" size={20} />;
  }

  return (
    <AddAddress
      handleClose={handleClose}
      handleSave={handleSave}
      isEditable={isEditable}
      externalAddress={externalAddress}
      childrenTop={childrenTop}
      childrenBottom={childrenBottom}
      disabled={disabled}
      configurations={configuration}
      externalError={externalError}
      externalUse={use}
      onDirtyChange={onDirtyChange}
    />
  );
};

export default AddAddressLoading;
